export function useUserAttributes() {
  const { host, href } = useRequestURL();
  const config = useRuntimeConfig().public;
  const routeQuery = useRoute().query;
  const otagQuery = typeof routeQuery.otag === 'string' ? routeQuery['otag'] : '';
  const midQuery = typeof routeQuery.mid === 'string' ? routeQuery['mid'] : '';
  const otag = useState('otag', () => otagQuery);
  const mid = useState('activeMid', () => midQuery);
  const brandCode = useState<string>('brandCode');

  return {
    channel: '',
    title: brandCode.value?.toUpperCase() || '', //@todo: Replace once title is available.
    otag: otag.value ?? '',
    mid: mid.value,
    flowStep: (routeQuery['flowStep'] as string) ?? '',
    campaign: '', //@todo: Replace once campaign is available.
    returning: '',
    productType: '', //@todo: Replace once productType is available.
    magazines: false, //@todo: Replace once title is available.
    host,
    url: href,
    environment: config.APPLICATION as string,
    country: '',
    $opt_user_agent: useRequestHeader('user-agent') ?? '',
  };
}
